import React from "react";
import { ForceGraph2D } from "react-force-graph";
import { v4 as uuidv4 } from "uuid";
import "../css/organigramme.css";
import useWindowSize from "../tools/useWindowSize";

const Organigramme = () => {
  const fgRef = React.useRef();
  const parentRef = React.useRef();
  const [centerNode, setCenterNode] = React.useState(undefined);
  const [maxsize, setMaxsize] = React.useState(1000000);
  const [fCoef, setFCoef] = React.useState(0.01 / 100);
  const [textCoef, setTextCoef] = React.useState(40 / 100);
  const [width, setWidth] = React.useState(1200);
  const [height, setHeight] = React.useState(200);
  const [idHovered, setIdHovered] = React.useState(0);
  const [dataReady, setDataReady] = React.useState();
  const size = useWindowSize();

  React.useEffect(() => {
    setWidth(parentRef.current.parentNode.clientWidth);
    setHeight(
      parentRef.current.parentNode.clientHeight -
        parentRef.current.parentNode.clientHeight * 0.05
    );

    fgRef.current.d3Force("link").distance(maxsize * fCoef);

    fgRef.current.d3Force("charge").strength(-800);
  }, [size]);

  React.useEffect(() => {
    const preparData = async (initialData) => {
      var nodes = await Promise.all(
        initialData.map(async (dt) => {
          const dataUrl = await toDataURL(dt.imgLink);
          
          const data = `
            <svg xmlns='http://www.w3.org/2000/svg' width='150' height='200'>
              <foreignObject width='100%' height='100%'>
                <div xmlns='http://www.w3.org/1999/xhtml' style='display : flex;border-radius : 30px; padding : 5px; border: 0.1px solid #FFFFFF;background: rgba(255, 255, 255, 0.23); box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); backdrop-filter: blur(7.5px); -webkit-backdrop-filter: blur(7.5px);'>
                  <div style="display : flex; flex-direction : column; justify-content : center;">
                    <div style="display : flex; justify-content : center; align-items : center; width : 20px ; height : 20px; background-color : #FFFFFF; border : solid 3px #95969D; border-radius: 50%; padding : 5px;">
                      <img src="${dataUrl}" style="max-width : 20px ; max-height : 20px; width : 20px; height : auto;"/> 
                    </div>
                  </div>
                  <div style="padding-left : 7px; display : flex; justify-content : center;flex-direction : column;">
                    <div style="color : ${dt.color}; font-family : Lexia; font-size : 10px; font-weight : bold; line-height: 10px;">${dt.name.replaceAll("&","et")}</div>
                    <div style="color : #FFFFFF; font-family : Lexia; font-size : 7px; line-height: 8.4px;margin-top : 4px;">${dt.subName.replaceAll("&","et")}</div>
                  </div>
                </div>
              </foreignObject>
            </svg>
          `;

          const img = new Image();
          const svg = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
          const url = URL.createObjectURL(svg);
          img.onload = function () {
            URL.revokeObjectURL(url);
          };
          img.src = url;
          
          return {
            id: uuidv4(),
            name: dt.name.replaceAll("&","et"),
            subName: dt.subName.replaceAll("&","et"),
            color: dt.color,
            link: dt.link,
            img: img,
            val: (1000000 * 0.005) / 100,
          };
        })
      );

      const dataUrl = await toDataURL(
        "/wp-content/uploads/2022/08/actif-conseil-logo.svg"
      );

      const data = `
        <svg xmlns='http://www.w3.org/2000/svg' width='310' height='310'>
          <foreignObject width='100%' height='100%'>
            <div xmlns='http://www.w3.org/1999/xhtml' style='width : 310px; height : 310px; display : flex; justify-content : center; align-items : center; border-radius : 50%; background: #00000030;'>
              <div style='width : 110px; height : 110px; display : flex; justify-content : center; align-items : center; border-radius : 50%; padding : 15px; background: #000000;'>
                <img src="${dataUrl}" style="width : 50px; height : auto;"/> 
              </div>
            </div>
          </foreignObject>
        </svg>
      `;

      const img = new Image();
      const svg = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(svg);
      img.onload = function () {
        URL.revokeObjectURL(url);
      };
      img.src = url;
      nodes.push({
        id: "centerID",
        link: "centerID",
        name: "ACTIF CONSEIL",
        subName: "ACTIF",
        color: "#000000",
        img: img,
        val: (1000000 * 0.005) / 100,
      });

      var links = nodes
        .map((node) => {
          if (node.id != "centerID") {
            return {
              source: "centerID",
              target: node.id,
            };
          }
        })
        .filter((link) => link);

      setDataReady({
        nodes: [...nodes],
        links: [...links],
      });
    };
    if (window && window.initialDataOrga) {
      preparData(window.initialDataOrga);
    }
  }, []);

  const handleClick = (node) => {
    if(document && document.getElementById(node.link)){
      document.getElementById(node.link).scrollIntoView({behavior: "smooth"});
    }
  };

  const toDataURL = (url) => {
    return new Promise((resolve) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  const lenpoint = (x1, y1, x2, y2, len) => {
    var dx = x2 - x1,
      dy = y2 - y1;
    var theta = Math.atan2(dy, dx);
    var xp = len * Math.cos(theta),
      yp = len * Math.sin(theta);
    return [xp + x1, yp + y1];
  };

  const getYPosition = (node) => {
    if (node.y < 0) {
      if (node.y > -20) {
        return node.y - 25;
      } else {
        if (-20 < node.x && node.x < 20) {
          return node.y - 49;
        } else {
          return node.y - 43;
        }
      }
    } else {
      if (node.y < 20) {
        return node.y - 25;
      } else {
        if (-20 < node.x && node.x < 20) {
          return node.y - 1;
        } else {
          return node.y - 5;
        }
      }
    }
  };

  const getXPosition = (node) => {
    if (node.x < 0) {
      if (-20 < node.y && node.y < 20) {
        return node.x - 150;
      } else {
        if (node.x > -20) {
          return node.x - 80;
        } else {
          return node.x - 140;
        }
      }
    } else {
      if (-20 < node.y && node.y < 20) {
        return node.x;
      } else {
        if (node.x < 20) {
          return node.x - 70;
        } else {
          return node.x - 10;
        }
      }
    }
  };

  return (
    <div className="Organigramme">
      <div ref={parentRef}>
        <ForceGraph2D
          cooldownTicks={100}
          onEngineStop={() => {
            if (fgRef.current) {
              if (centerNode) {
                fgRef.current.centerAt(centerNode.x, centerNode.y, 400);
              }
            }
          }}
          enableNodeDrag={false}
          enableNavigationControls={false}
          enableZoomInteraction={false}
          enableZoomPanInteraction={false}
          width={width}
          minZoom={1}
          height={height}
          ref={fgRef}
          graphData={dataReady}
          backgroundColor={"rgba(0,0,0,0)"}
          linkWidth={1}
          linkColor={"#FFFFFF"}
          nodeCanvasObject={async (node, ctx) => {
            if (node.id == "centerID") {
              setCenterNode(node);

              ctx.beginPath();
              ctx.drawImage(node.img, node.x - 155, node.y - 155);
            } else {
              ctx.beginPath();
              ctx.drawImage(node.img, getXPosition(node), getYPosition(node));
            }
          }}
          nodePointerAreaPaint={(node, color, ctx) => {
            if (node.id == "centerID") {
              ctx.fillStyle = color;
              ctx.fillRect(node.x - 65, node.y - 65, 140, 140);
            } else {
              ctx.fillStyle = color;
              ctx.fillRect(
                node.x < 0 ? node.x - 140 : node.x - 10,
                node.y < 0 ? node.y - 45 : node.y - 5,
                150,
                50
              );
            }
          }}
          linkCanvasObject={(link, ctx, globalScale) => {
            const start = link.source;
            const end = link.target;
            // ignore unbound links
            if (typeof start !== "object" || typeof end !== "object") return;
            // draw link line
            ctx.beginPath();
            ctx.setLineDash([1, 1]);
            ctx.moveTo(start.x, start.y);
            ctx.lineTo(end.x, end.y);
            ctx.strokeStyle = "#FFFFFF";
            ctx.stroke();

            ctx.beginPath();
            ctx.fillStyle = "#FFFFFF";
            var pointCenter = lenpoint(start.x, start.y, end.x, end.y, 72);
            
            ctx.arc(pointCenter[0], pointCenter[1], 2, 0, 2 * Math.PI, false);
            ctx.fill();
          }}
          onNodeClick={(node) => {
            handleClick(node);
          }}
          nodeRelSize={4}
        />
      </div>
    </div>
  );
};

export default Organigramme;
